export default class LockedUserSerializer {
  static serialize(data) {
    const payload = {
      ...data,
      parent_row_id: data.movementId,
      sequence: data.sequence,
      user_id: data.userId
    };

    const customProperties = [
      "movementId",
      "userId"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
      movementId: data.parent_row_id,
      sequence: data.sequence,
      userId: data.user_id
    };
  }
}